import { Reducer } from "redux";
import { ReInit, ReinitActionTypes } from ".";

export const createReducerWithReinit = <State>(getRootReducer: F<Reducer<State>>): Reducer<State> => {
    const rootReducer = getRootReducer();

    return (state: State, action: ReInit) => {
        if (action.type === ReinitActionTypes.APP_REINIT) {
            state = undefined;
        }

        return rootReducer(state, action);
    };
};
